import { ErrorIcon } from '@icons';
import { Button } from '@iwoca/orion';
import { RootState } from '@iwProvider/configureStore';
import { ErrorText, H2, Input, Label, SuccessText, Text } from '@ui';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';

import messages from './AccountDetails.messages';
import { usePostApi } from './postApi.hook';
import { getApplicantEmail } from '../../../api/lendingAPI/CustomerStateAPIHelper';
import { GreenTickStatusSVG } from '../../../svgComponents/greenTickStatusSVG/index';
import { InformationSVG } from '../../../svgComponents/informationSVG/index';
import profileMessages from '../Profile.messages';

const mapStateToProps = (state: RootState) => ({
    accountEmail: getApplicantEmail(state)
});

const AccountDetails = ({
    accountEmail
}: ReturnType<typeof mapStateToProps>) => {
    const intl = useIntl();
    const { status, hasError, isLoading, triggerFetch } = usePostApi({
        endpoint: '/api/lending/edge/password/reset/'
    });

    return (
        <div className="space-y-xl">
            <H2>
                <FormattedMessage {...profileMessages.accountDetailsTitle} />
            </H2>

            <div className="space-y-l rounded-m border border-secondary-90 bg-structure-100 p-l">
                <div className="flex flex-col items-start space-y-s">
                    <Label htmlFor="account-email">
                        <FormattedMessage {...messages.accountEmail} />
                    </Label>
                    {/* eslint-disable-next-line iwoca/input-a11y */}
                    <Input
                        className="w-full max-w-xl"
                        id="account-email"
                        name="account-email"
                        disabled
                        value={accountEmail}
                    />
                </div>

                <div className="space-y-s">
                    <Text>
                        <FormattedMessage {...messages.setNewPassword} />
                    </Text>
                    <Button
                        onClick={() =>
                            triggerFetch({ data: { email: accountEmail } })
                        }
                        loading={isLoading}
                    >
                        <FormattedMessage {...messages.resetPasswordCTA} />
                    </Button>

                    {!hasError && status === 204 ? (
                        <div className="flex items-center">
                            <GreenTickStatusSVG className="mr-xs shrink-0" />
                            <SuccessText>
                                <FormattedMessage
                                    {...messages.successSentResetPassword}
                                />
                            </SuccessText>
                        </div>
                    ) : null}

                    {hasError && status !== 204 ? (
                        <div className="flex items-center">
                            <ErrorIcon className="mr-xs shrink-0" />
                            <ErrorText>
                                <FormattedMessage
                                    {...messages.failureResetPassword}
                                />
                            </ErrorText>
                        </div>
                    ) : null}
                </div>

                <div className="flex items-center">
                    <InformationSVG className="mr-xs shrink-0" />
                    <Text
                        className="text-s font-med"
                        dangerouslySetInnerHTML={{
                            __html: intl.formatMessage(messages.changeEmailInfo)
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(AccountDetails);
